import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'date',
})
export class DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!value) return value
    return new Date(value).toLocaleDateString(undefined, {
      // weekday: 'long',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    })
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/pipe/date.pipe.ts